import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Token, url } from "../../Script/Session";
import { post } from "../../Script/Session";
import { Typography, Button, CircularProgress, Box } from "@mui/joy";
import NavigationBar from "../../components/Navigationbar/Navigationbar";
import "./Pagehistory.css";
import { Table } from "@mui/joy";

const Pagehistory = () => {
  const { page } = useParams();
  const navigate = useNavigate();
  const [data, setdata] = useState({});
  const [fdata, setfdata] = useState({});
  const [offset, setoffset] = useState(0);
  const [loading, setLoading] = useState(false);  // Loading state for the fetch

  useEffect(() => {
    const fetchVereinData = async () => {
      setLoading(true); // Set loading to true before fetching data
      const body = {
        token: Token.get(),
        page: "/" + page,
        offset: String(offset),
      };

      try {
        let response = await post(body, "/pagehistory");

        if (response === "LOGOUT") {
          navigate("/");
          return;
        }

        setdata(JSON.parse(response));
        setfdata(JSON.parse(response));
        console.log(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Set loading to false after fetch is complete
      }
    };

    // Delay the fetch to avoid blocking render
    setTimeout(() => {
      fetchVereinData(); // Start fetch operation after a slight delay
    }, 100);  // Delay by 100ms for smoother rendering

  }, [navigate, page, offset]);

  const [wit, setwith] = useState("90.5%");

  function search(event) {
    if (event.key !== 'Enter') {
      return;
    }
    let value = document.getElementById("search-page-history-ss").value;
    if (value === " " || value === "") {
      return;
    }
    const body = {
      token: Token.get(),
      page: "/" + page,
      searchpattern: value,
    };
    let response = post(body, "/pagehistory");
    if (response === "LOGOUT") {
      navigate("/");
      return;
    }
    setfdata(JSON.parse(response));
    console.log(response);
  }

  function cancelsearch() {
    let value = document.getElementById("search-page-history-ss").value;
    if (value === " " || value === "") {
      setfdata(data);
    }
  }

  return (
    <>
      <div
        style={{
          width: wit,
          backgroundColor: "white",
          position: "fixed",
          height: "100vh",
          right: 0,
          top: 0,
          transition: "all 0.5s ease",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          backgroundColor: "#f8f9fa",
          borderLeft: "1px solid #ddd",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: "10px",
          }}
        >
          <label
            style={{
              fontSize: "1.2rem",
              fontWeight: "bold",
              marginLeft: "10px",
            }}
          >
            Seitenhistorie von {page}
          </label>
          <div
            style={{
              display: "flex",
              marginRight: "5%",
              width: "30%",
              alignItems: "center",
            }}
          >
            <svg
              style={{ width: "20px", height: "20px", marginRight: "5px" }}
              aria-hidden="true"
              viewBox="0 0 24 24"
            >
              <g>
                <path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path>
              </g>
            </svg>
            <input
              onChange={cancelsearch}
              onKeyDown={search}
              placeholder="Suchen"
              type="search"
              id="search-page-history-ss"
              style={{
                flex: 1,
                padding: "5px 10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            />
          </div>
        </div>
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "15px",
            display: "flex",
            flexDirection: "column",
            height: "calc(100% - 60px)",
            width: "100%",
            overflowY: "auto",
            padding: "10px",
          }}
        >
          {loading ? (
            <Button loading variant="outlined" startIcon={<CircularProgress size={24} />}>
              Laden...
            </Button>
          ) : fdata && fdata.value && fdata.value.length > 0 ? (
            <Table sx={{ '& thead th:nth-child(1)': { width: '33%' } }}>
              <thead>
                <tr>
                  <th>Nutzer</th>
                  <th>Zeit</th>
                  <th>Aktion</th>
                  <th>Zusatz</th>
                </tr>
              </thead>
              <tbody>
                {fdata.value.slice()
                  .sort((a, b) => b.long - a.long).map((item) => (
                    <tr key={item.name}>
                      <td>{item.name}</td>
                      <td>{item.time}</td>
                      <td>{item.text}</td>
                      <td>
                        {
                          item.additional && Object.keys(JSON.parse(item.additional))[0] == "showtable" && (
                            <Button onClick={() => {
                              const parsed = JSON.parse(item.additional);
                              navigate("/history_table", { state: { showtable: parsed.showtable } });
                            }}>Details anzeigen
                            </Button>

                          )
                        }
                        {
                          item.additional && Object.keys(JSON.parse(item.additional))[0] == "download_file" && (
                            <Button onClick={() => {
                              window.open(
                                `${url}/api/filedownload/${JSON.parse(item.additional).download_file}/Historien_download_${JSON.parse(item.additional).download_file}.${JSON.parse(item.additional).endung}`,
                                "_blank",
                                "noopener,noreferrer"
                              )
                            }}>
                              Download
                            </Button>
                          )
                        }
                        {
                          item.additional && Object.keys(JSON.parse(item.additional))[0] == "filedownload" && (
                            <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
                              <Button onClick={() => {
                                window.open(
                                  `${url}/api/filedownload/${JSON.parse(item.additional).filedownload.old}/Historien_download_${JSON.parse(item.additional).filedownload.old}.${JSON.parse(item.additional).filedownload.oldendung}`,
                                  "_blank",
                                  "noopener,noreferrer"
                                )
                              }}>
                                vorher
                              </Button>
                              <Button onClick={() => {
                                window.open(
                                  `${url}/api/filedownload/${JSON.parse(item.additional).filedownload.new}/Historien_download_${JSON.parse(item.additional).filedownload.new}.${JSON.parse(item.additional).filedownload.newendung}`,
                                  "_blank",
                                  "noopener,noreferrer"
                                )
                              }}>
                                nacher
                              </Button>
                            </Box>
                          )
                        }
                        {
                          item.additional && Object.keys(JSON.parse(item.additional))[0] == "show_edit_empfehlung" && (
                            <Button onClick={() => {
                              localStorage.setItem("addi",item.additional)
                              window.open(
                                `${window.location.origin}/tarifstand_empfehlung_log/-1`
                              )
                            }}>
                              Details anzeigen
                            </Button>
                          )
                        }

                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          ) : (
            <Button loading variant="outlined" sx={{ width: "10%" }} startIcon={<CircularProgress size={24} />}>
              Laden...
            </Button>
          )}
        </div>
      </div>
      <div>
        <NavigationBar state={"verein"} back={true} />
      </div>
    </>
  );
};

export default Pagehistory;
